export default function filterString(filters = []) {
  return filters.map((filter) => {

    return 'filter[' + filter.attr + ']=' + filter.value;

  }).join(',');


}
